var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagination"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/forge/cpmec.stagingwebsite.dev/web/app/themes/cpmec/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/forge/cpmec.stagingwebsite.dev/web/app/themes/cpmec/node_modules/vue-loader/lib?{}!./scripts/vue/SitePagination.vue?vue&type=template&id=149941dd&scoped=true&
// module id = 237
// module chunks = 0